import { GetWamPhotoUploadTag } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

/**
 * Gets the modal and product tag to track when user opens image upload drawer
 * via toolbar or photozone button
 *
 * @param options attributes to be included in product tag and modal event tag
 * @returns
 */
export const getWamPhotoUploadTag = (options: GetWamPhotoUploadTag) => {
  const photoUploadEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    {
      eventInfo: {
        eventName: 'photo upload',
        eventAction: options.imageSize,
      },
    },
  ];

  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal, user } = getModalTag(options.productType, 'Edit Mode', photoUploadEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
